(function() {
  var Phone, PhoneNumber, nanp;

  Phone = require('../Phone');

  PhoneNumber = require('../PhoneNumber');

  nanp = require('./NANP');

  module.exports = nanp;

}).call(this);
